var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 0H13.75C13.0586 0 12.5 0.574553 12.5 1.28571C12.5 1.99687 13.0586 2.57143 13.75 2.57143H16.25C16.9402 2.57143 17.5 3.14719 17.5 3.85714V14.1429C17.5 14.8528 16.9402 15.4286 16.25 15.4286H13.75C13.0586 15.4286 12.5 16.0043 12.5 16.7143C12.5 17.4242 13.0586 18 13.75 18H16.25C18.3211 18 20 16.2731 20 14.1429V3.85714C20 1.72768 18.3211 0 16.25 0ZM0.28125 9.70312L5.91016 15.1674C6.18262 15.4317 6.58203 15.5039 6.92578 15.352C7.26965 15.1994 7.49258 14.851 7.49258 14.4661L7.49616 11.5732L12.4962 11.5732C13.1872 11.5732 13.7469 10.9975 13.7469 10.2875V7.71609C13.7469 7.00614 13.1868 6.43038 12.4962 6.43038L7.49616 6.43034L7.49258 3.57364C7.49258 3.18881 7.26965 2.84038 6.92578 2.68771C6.58191 2.53579 6.18242 2.60799 5.91016 2.87229L0.28125 8.33657C-0.09375 8.6625 -0.09375 9.3375 0.28125 9.70312Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOut);
export default __webpack_public_path__ + "static/media/sign-out.22b1afbaeaab5a074e1c57053b0ab805.svg";
export { ForwardRef as ReactComponent };